export default __webpack_public_path__ + "static/media/nrpc.da65714b.png";